<template>
  <div>
    <div style="height:60px;background-color:#ffffff;text-align:center">
      <img src="assets/mt_108_108.png" height="100%" />
    </div>
    <el-menu
      mode="vertical"
      router
      :default-active="select"
      :collapse="collapse"
      :unique-opened="false"
      :collapse-transition="false"
      class="el-menu-verical-demo"
    >
      <menu-item v-for="menu in menus" :key="menu.to" :collapse="collapse" :item="menu" />
    </el-menu>
  </div>
</template>

<script>
import menus from "../../config/menus";
import MenuItem from "./menuItem";
export default {
  components: { MenuItem },
  props: { collapse: { type: Boolean, default: false } },
  data: () => ({
    menus: menus
  }),
  computed: {
    select() {
      return this.$route.path;
    }
  },
  watch: {
    collapse: {
      handler() {
        let _this = this;
        setTimeout(function() {
          _this.$bus.$emit("sizeChange", 1);
        }, 550);
      }
    }
  }
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
}
</style>